var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCourseIconIntermediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.76 173.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#3668f1;}.cls-5{fill:url(#radial-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#radial-gradient-2);}.cls-8{fill:url(#radial-gradient-3);}.cls-9{fill:url(#radial-gradient-4);}.cls-10{fill:#fff;}.cls-11{fill:#e6e6e6;}.cls-12{clip-path:url(#clip-path-3);}.cls-13{fill:url(#radial-gradient-5);}.cls-14{fill:url(#radial-gradient-7);}.cls-15{fill:url(#radial-gradient-8);}.cls-16{fill:url(#radial-gradient-9);}.cls-17{fill:url(#radial-gradient-10);}.cls-18{fill:url(#radial-gradient-11);}.cls-19{fill:url(#radial-gradient-12);}.cls-20{fill:#53d669;}.cls-21{fill:url(#radial-gradient-13);}.cls-22{fill:url(#radial-gradient-14);}.cls-23{fill:url(#radial-gradient-15);}.cls-24{fill:url(#radial-gradient-16);}.cls-25,.cls-28,.cls-30{mix-blend-mode:overlay;}.cls-25{fill:url(#radial-gradient-17);}.cls-26{fill:url(#radial-gradient-18);}.cls-27{fill:url(#radial-gradient-19);}.cls-28{fill:url(#radial-gradient-20);}.cls-29{fill:url(#radial-gradient-21);}.cls-30{fill:url(#radial-gradient-22);}.cls-31{fill:#00bdb3;}.cls-32{fill:#fb3259;}.cls-33{fill:#c92847;}.cls-34{fill:#368b44;}.cls-35{clip-path:url(#clip-path-4);}.cls-36{fill:#924f31;}.cls-37{fill:#00bab1;}.cls-38{fill:#b7633e;}.cls-39{fill:#fdd53c;}.cls-40{clip-path:url(#clip-path-5);}.cls-41{fill:#846f1f;}.cls-42{fill:#00fff2;}.cls-43{fill:url(#radial-gradient-23);}.cls-44{fill:url(#radial-gradient-24);}.cls-45{fill:url(#radial-gradient-25);}.cls-46{clip-path:url(#clip-path-6);}.cls-47{clip-path:url(#clip-path-7);}.cls-48{fill:url(#radial-gradient-26);}.cls-49{fill:url(#radial-gradient-27);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.24 133.76 113.58 68.88 194.14 108.17 93.8 173.05 13.24 133.76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 91.48,
    cy: 146.87,
    r: 164.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#458af7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#488af7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#528cf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#638ff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7b92fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9a97fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#bf9cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d19fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.48 92.37 121.33 21.3 221.76 63.7 100.91 140.53 0.48 92.37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 109.54,
    cy: 209.85,
    r: 171.18,
    gradientTransform: "translate(13.11 10.82) scale(1.02 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 109.54,
    cy: 215.33,
    r: 180.45,
    gradientTransform: "translate(13.11 10.82) scale(1.02 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 236.65,
    cy: 184.39,
    r: 360.26,
    gradientTransform: "translate(13.11 10.82) scale(1.02 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.48 77.97 121.33 1.14 221.76 49.3 100.91 126.14 0.48 77.97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 109.54,
    cy: 205.21,
    r: 184.52,
    gradientTransform: "translate(13.11 10.82) scale(1.02 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 236.65,
    cy: 177.68,
    r: 371.84,
    gradientTransform: "translate(13.11 10.82) scale(1.02 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 54.45,
    cy: 1.91,
    r: 168.05,
    gradientTransform: "translate(98.17 -30.57) rotate(141.65) scale(1 0.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#033b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 150.76,
    cy: 31.83,
    r: 101.53,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 103.74,
    cy: 5.06,
    r: 142.03,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 80.46,
    cy: 76.85,
    r: 128.31,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 141.73,
    cy: 155.1,
    r: 184.51,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 46.76,
    cy: 112.07,
    r: 29.2,
    gradientTransform: "matrix(1.1, -0.19, 0, 1, -40.99, -28.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#147a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147a1b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 156.08,
    cy: 148.61,
    r: 60.02,
    gradientTransform: "matrix(1.1, -0.19, 0, 1, -40.99, -28.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16851d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16851d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 78.83,
    cy: 173.02,
    r: 54.93,
    gradientTransform: "matrix(1.1, -0.19, 0, 1, -40.99, -28.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a9d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a9d22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 143.72,
    cy: 155.4,
    r: 34.59,
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 81.55,
    cy: 123.91,
    r: 27.2,
    gradientTransform: "matrix(0.97, 0.28, -0.18, 0.36, -8.42, 12.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 89.71,
    cy: 148.1,
    r: 26.86,
    gradientTransform: "matrix(1.09, -0.3, 0.04, 0.36, -46.6, 75.78)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 44.5,
    cy: 157.66,
    r: 39.26,
    gradientTransform: "matrix(0.96, -0.65, 0.22, 0.33, -69.3, 97.69)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 49.18,
    cy: 135.21,
    r: 38.86,
    gradientTransform: "matrix(1.06, -0.44, 0.08, 0.25, -49.42, 85.78)",
    xlinkHref: "#radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 95.72,
    cy: 168.43,
    r: 17.04,
    gradientTransform: "matrix(1.1, -0.19, 0, 1.71, -40.99, -147.3)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 73.57,
    cy: 155.6,
    r: 17.14,
    gradientTransform: "matrix(1.1, -0.19, 0, 1, -40.99, -28.34)",
    xlinkHref: "#radial-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.19,21.81l.33,21.11c-10.77-1.87-21.53-3.76-27-4.71l-.34-21.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.2,32.8l.33,21.11C122.65,45.3,121,38,120.92,37.58l-.33-21.11C120.68,16.86,122.32,24.2,124.2,32.8Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 165.34,
    cy: 83.22,
    r: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff004f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff004f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 165.34,
    cy: 83.22,
    r: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6200ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 144.6,
    cy: 47.79,
    r: 17.92,
    xlinkHref: "#radial-gradient-23"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.67,50.7l.22,8.92c-7.41-1.29-14.82,3-18.56,2.37l-.23-14.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.09,58.26l.23,8.92c-1.3-5.92-2.43-5.36-2.49-5.63L162.6,47C162.66,47.29,163.79,52.34,165.09,58.26Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 199.06,
    cy: 97.69,
    r: 88.26,
    xlinkHref: "#radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 199.06,
    cy: 97.69,
    r: 88.26,
    xlinkHref: "#radial-gradient-24"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Statistical Process Control") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.14 108.17 113.58 68.88 13.24 133.76 93.8 173.05 194.14 108.17"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 77.94 0 92.34 46.31 76.44 44.26 51.55 0 77.94"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "127.12 24.07 121.33 21.3 0.48 92.37 6.26 95.15 127.12 24.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "221.76 63.7 131.38 26.12 10.53 97.19 100.91 140.53 221.76 63.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "131.38 26.12 127.12 24.07 6.26 95.15 10.53 97.19 131.38 26.12"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216,52v9.6L100,135.73,4.76,89.51l.1-.06H4.8c1.85,0,1.85-9.79,0-9.79l30.86-4,90-57.19L200,54.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "101.76 110.58 99.84 135.54 216 61.62 216 49.14 101.76 110.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "127.12 3.91 121.33 1.14 0.48 77.97 6.26 80.75 127.12 3.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "221.76 49.3 131.38 5.96 10.53 82.79 100.91 126.14 221.76 49.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "131.38 5.96 127.12 3.91 6.26 80.75 10.53 82.79 131.38 5.96"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "221.76 49.3 131.38 5.96 10.53 82.79 100.91 126.14 221.76 49.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.73,68.75a28.92,28.92,0,0,0,9.82-1.06c3.13-1.06,6-3.28,7.13-6.4s-.05-7.09-3-8.54a10,10,0,0,0-6.1-.36c-5.45,1-10.57,3.2-15.56,5.54-2.54,1.2-5.06,2.43-7.63,3.58-1.92.86-7.15-.44-8.44,1.07a40.23,40.23,0,0,0,12.48,4.8A78.92,78.92,0,0,0,169.73,68.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M130.27,56.71c4.63.09,9.35,0,13.73-1.48s8.44-4.59,10-8.95-.07-9.93-4.23-12c-2.61-1.27-5.69-1-8.54-.51-7.63,1.39-14.79,4.49-21.77,7.76-3.56,1.67-7.08,3.4-10.67,5-2.68,1.2-10-.62-11.81,1.5a56.54,56.54,0,0,0,17.46,6.71C119.86,55.65,124.77,56.61,130.27,56.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M42.53,84.24C40.66,81,40,76.85,41.74,73.56a11.11,11.11,0,0,1,5.87-4.84A32.94,32.94,0,0,1,55.18,67c-4.28-1.47-8.69-3-13.2-2.66s-9.19,2.86-10.57,7.17c-1.08,3.38.06,7.1,1.9,10.14a23.11,23.11,0,0,0,7,7.23c2.16,1.43,6.71,4.15,9.36,3.47-.14-1.17-2.73-2.78-3.62-3.68A22.3,22.3,0,0,1,42.53,84.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M99.84,110.58c5.76-1,14.84-3.62,19.2-7.68,5.21-4.85,5.13-11.46,3.84-17.28C121,77,120,78.9,113.4,75.27c2.7,5.24,5.41,11.57,2.61,16.77-2.18,4-7,5.85-11.46,6.89a73.63,73.63,0,0,1-26.09,1.31c-4.31-.55-12-2.81-16.07-.54-5.39,3-1.32,3.67,1.93,5.12C74.56,109.38,88.78,112.42,99.84,110.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M116.37,90.81c-1.36-6.37-9.82-13.18-23.85-18-22.76-7.75-49.28-6.64-59.19,1.6a13.92,13.92,0,0,0-1.18,1.1C28.2,70.22,28.23,64.8,33.4,60.6c10.56-8.59,38.75-9,62.83.06C119.57,69.43,127.86,82.85,116.37,90.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M116.37,90.81c-1.36-6.37-9.82-13.18-23.85-18-22.76-7.75-49.28-6.64-59.19,1.6a13.92,13.92,0,0,0-1.18,1.1C28.2,70.22,28.23,64.8,33.4,60.6c10.56-8.59,38.75-9,62.83.06C119.57,69.43,127.86,82.85,116.37,90.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M116.37,90.81c-1.36-6.37-9.82-13.18-23.85-18-22.76-7.75-49.28-6.64-59.19,1.6a13.92,13.92,0,0,0-1.18,1.1C28.2,70.22,28.23,64.8,33.4,60.6c10.56-8.59,38.75-9,62.83.06C119.57,69.43,127.86,82.85,116.37,90.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M121,79.37c-1.18,6-3.73,12-13.34,15.24-14.65,4-37.43,1.79-55.34-5.49a63.3,63.3,0,0,1-14.17-7.75A17.07,17.07,0,0,1,32,72.67a19.3,19.3,0,0,1-.14-10.41S25,68,27.69,78.69a21.69,21.69,0,0,0,4.59,8.73,44.94,44.94,0,0,0,18.95,13.07c17.91,6.39,40.65,8,54.34,3.07C108.05,102.82,124.09,97.26,121,79.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M121,79.37c-1.18,6-3.73,12-13.34,15.24-14.65,4-37.43,1.79-55.34-5.49a63.3,63.3,0,0,1-14.17-7.75A17.07,17.07,0,0,1,32,72.67a19.3,19.3,0,0,1-.14-10.41S25,68,27.69,78.69a21.69,21.69,0,0,0,4.59,8.73,44.94,44.94,0,0,0,18.95,13.07c17.91,6.39,40.65,8,54.34,3.07C108.05,102.82,124.09,97.26,121,79.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M121,79.37c-1.18,6-3.73,12-13.34,15.24-14.65,4-37.43,1.79-55.34-5.49a63.3,63.3,0,0,1-14.17-7.75A17.07,17.07,0,0,1,32,72.67a19.3,19.3,0,0,1-.14-10.41S25,68,27.69,78.69a21.69,21.69,0,0,0,4.59,8.73,44.94,44.94,0,0,0,18.95,13.07c17.91,6.39,40.65,8,54.34,3.07C108.05,102.82,124.09,97.26,121,79.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M59.33,100.13a8.39,8.39,0,0,0,6.19-2.22,5.36,5.36,0,0,0,1.57-3.4c.11-2.15-1.37-3.9-3.23-5a24,24,0,0,0-6.15-2.15L52.4,86.05c-1.91-.48-4-1-6-.2-2.56,1-4.22,4-3.41,6.23.6,1.64,2.25,2.61,3.82,3.48C50.55,97.62,54.45,100,59.33,100.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M59.33,100.13a8.39,8.39,0,0,0,6.19-2.22,5.36,5.36,0,0,0,1.57-3.4c.11-2.15-1.37-3.9-3.23-5a24,24,0,0,0-6.15-2.15L52.4,86.05c-1.91-.48-4-1-6-.2-2.56,1-4.22,4-3.41,6.23.6,1.64,2.25,2.61,3.82,3.48C50.55,97.62,54.45,100,59.33,100.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M59.33,100.13a8.39,8.39,0,0,0,6.19-2.22,5.36,5.36,0,0,0,1.57-3.4c.11-2.15-1.37-3.9-3.23-5a24,24,0,0,0-6.15-2.15L52.4,86.05c-1.91-.48-4-1-6-.2-2.56,1-4.22,4-3.41,6.23.6,1.64,2.25,2.61,3.82,3.48C50.55,97.62,54.45,100,59.33,100.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M55.48,91s-36.55.57-52.74,15.13A17.59,17.59,0,0,0,4.23,116.2S21.6,99,56.49,100.1C57.79,91.72,55.48,91,55.48,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M55.48,91s-36.55.57-52.74,15.13A17.59,17.59,0,0,0,4.23,116.2S21.6,99,56.49,100.1C57.79,91.72,55.48,91,55.48,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M55.48,91s-36.55.57-52.74,15.13A17.59,17.59,0,0,0,4.23,116.2S21.6,99,56.49,100.1C57.79,91.72,55.48,91,55.48,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M56,91.42s13.67,20.84,1.49,44.41c-16.65-.32-12.6-.52-12.6-.52S62,106.34,46.38,101C31,95.82,56,91.42,56,91.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M56,91.42s13.67,20.84,1.49,44.41c-16.65-.32-12.6-.52-12.6-.52S62,106.34,46.38,101C31,95.82,56,91.42,56,91.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M56,91.42s13.67,20.84,1.49,44.41c-16.65-.32-12.6-.52-12.6-.52S62,106.34,46.38,101C31,95.82,56,91.42,56,91.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "139.64 2.88 139.97 23.99 120.92 37.58 120.59 16.47 139.64 2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M120.59,16.47l19-13.59a28,28,0,0,1,9.53,5.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "149.17 8.22 149.5 29.33 120.92 37.58 120.59 16.47 149.17 8.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "121.44 16.62 121.77 37.73 120.92 37.58 120.59 16.47 121.44 16.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "121.84 16.69 122.17 37.8 121.77 37.73 121.44 16.62 121.84 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "122.68 16.84 123.02 37.95 122.17 37.8 121.84 16.69 122.68 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "123.71 17.02 124.05 38.13 123.02 37.95 122.68 16.84 123.71 17.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "124.22 17.11 124.56 38.22 124.05 38.13 123.71 17.02 124.22 17.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M153.35,38.91c0-.09,0-.18.05-.26a1.1,1.1,0,0,0,0-.16,3.05,3.05,0,0,0,0-.41l0-.23q0-.37,0-.75v0L153.2,16a5.4,5.4,0,0,1,0,.8,1.8,1.8,0,0,1,0,.22c0,.19-.05.38-.08.57s0,.17,0,.26-.08.36-.13.54,0,.18-.08.26a7.75,7.75,0,0,1-.26.77,11.33,11.33,0,0,1-.53,1.12l-.09.16a10.47,10.47,0,0,1-.71,1.12h0l.34,21.11.23-.34c.17-.26.33-.52.48-.79,0,0,0-.1.08-.16l.21-.38c.12-.24.22-.49.32-.74s.16-.41.23-.62a.74.74,0,0,1,0-.14c0-.09,0-.17.07-.26S153.31,39.09,153.35,38.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "151.22 21.77 151.56 42.88 124.56 38.22 124.22 17.11 151.22 21.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M120.59,16.47l28.58-8.25c3.59,3.25,5,7.16,3.38,11.15a11.41,11.41,0,0,1-1.33,2.4l-27-4.66-.51-.09-1-.18-.84-.15-.4-.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M151.19,21.81l.33,21.11c-10.77-1.87-21.53-3.76-27-4.71l-.34-21.1,27,4.7"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M124.22,17.11l27,4.66,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.22 21.77 151.56 42.88 151.52 42.92 151.19 21.81 151.22 21.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M150.73,43.92l.09-.11c.25-.29.49-.59.7-.89l-.33-21.11c-.22.3-.46.6-.71.89l-.24.28c-.12.14-.25.27-.38.41l-.29.3-.42.4-.46.42c-.3.26-.62.52-.95.78l-.33.24-.72.51-.35.24c-.24.16-.49.32-.75.47l-.38.24-.87.49-.3.17-1.21.61q-.78.38-1.59.72l-.44.17c-.4.17-.81.33-1.23.49l-.62.22c-.38.14-.76.27-1.15.39q-.33.12-.66.21l-1.25.37-.58.16c-.77.21-1.56.4-2.37.58l-.52.11c-.79.16-1.6.32-2.42.45l-.16,0-1,.14-.87.13-1,.11-.86.1c-.64.06-1.29.12-1.94.16h0l.33,21.11,1.94-.16h0l.84-.09,1-.12.87-.12,1-.14h0l.11,0c.82-.14,1.63-.29,2.42-.46l.52-.11c.81-.17,1.6-.36,2.38-.57l.14,0,.44-.12,1.24-.37.66-.21,1.16-.39.61-.22c.42-.16.83-.32,1.23-.49l.45-.18c.54-.23,1.07-.47,1.58-.71l.05,0c.4-.19.78-.39,1.16-.59.11,0,.2-.11.31-.17.29-.16.58-.32.86-.49l.39-.23.74-.47.36-.24.18-.12.53-.39.33-.25c.33-.25.65-.51,1-.77l.28-.25.19-.18.41-.39.3-.3.37-.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M124.2,32.8l.33,21.11C122.65,45.3,121,38,120.92,37.58l-.33-21.11c.09.39,1.73,7.73,3.61,16.33"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M120.59,16.47l.85.15.4.07.84.15,1,.18.51.09,27,4.7a15.71,15.71,0,0,1-2.5,2.7c-5.19,4.51-14.3,7.6-24.49,8.29C122.32,24.2,120.68,16.86,120.59,16.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M123.33,54l1.2-.07L124.2,32.8c-.58,0-1.17.06-1.76.09l-1.65,0H119.7l-1.51,0-1.14,0c-.48,0-1-.05-1.45-.09s-1,0-1.47-.1-1.22-.12-1.82-.19l-.42-.06c-.78-.1-1.56-.21-2.31-.34l-.32-.05c-.81-.15-1.61-.3-2.39-.48l-.44-.1c-.3-.06-.59-.14-.89-.21l-.51-.13-.92-.25-.41-.12-1.51-.47-.34-.12c-.42-.14-.82-.29-1.22-.44l-.31-.12c-.42-.16-.84-.34-1.25-.51l-.22-.1c-.34-.15-.67-.3-1-.46l-.36-.17-.85-.44-.3-.16c-.36-.2-.72-.4-1.06-.61l-.16-.1-.84-.55-.29-.2-.68-.5-.25-.19c-.29-.23-.58-.46-.84-.69l-.1-.09c-.23-.21-.46-.42-.67-.64L91.24,24c-.18-.18-.35-.36-.51-.55l-.19-.21c-.21-.25-.41-.51-.6-.76l0-.08c-.17-.23-.32-.47-.47-.71l-.14-.24L89,20.85a2.56,2.56,0,0,1-.11-.24c-.13-.27-.25-.54-.35-.81,0,0,0,0,0,0-.09-.26-.17-.53-.24-.79l-.06-.25c0-.21-.08-.41-.11-.62s0-.17,0-.25A7.91,7.91,0,0,1,88,17l.33,21.11c0,.28,0,.57.06.85,0,.08,0,.16,0,.25s.07.41.12.62,0,.16.06.25a7.67,7.67,0,0,0,.23.78s0,0,0,0a8.33,8.33,0,0,0,.34.82l.12.23a6.63,6.63,0,0,0,.31.59l.15.24c.14.24.3.48.46.71l.06.07a8.32,8.32,0,0,0,.6.76,2,2,0,0,0,.19.22l.5.55.22.22.67.63.1.09c.27.24.55.47.84.7l.25.19.68.49.3.21.83.54.16.1c.35.21.7.42,1.06.62L97,49l.85.43.36.18,1,.46.22.09c.41.18.83.35,1.26.52l.09,0,.21.07c.4.16.8.3,1.22.44l.34.12c.5.17,1,.33,1.52.48l.08,0a3,3,0,0,0,.32.09l.93.26.5.13.89.21.29.07.15,0c.78.17,1.58.33,2.39.47l.17,0,.15,0c.76.13,1.53.24,2.32.34l.19,0,.22,0c.6.08,1.21.14,1.82.2l.58.05.89,0,1.45.09.34,0h.8l1.51,0c.14,0,.29,0,.43,0h.66c.56,0,1.11,0,1.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M92.49,8.45c6.86-6,20.57-9.46,34.57-8.19a52.4,52.4,0,0,1,12.58,2.62l-19,13.59c.09.39,1.73,7.73,3.61,16.33a64,64,0,0,1-10.07-.11c-17.65-1.6-29.06-10.15-25.5-19.1A13.57,13.57,0,0,1,92.49,8.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M153.54,37.06,153.2,16a5.4,5.4,0,0,1,0,.8,1.8,1.8,0,0,1,0,.22c0,.19-.05.38-.08.57s0,.17,0,.26-.08.36-.13.54,0,.18-.08.26a7.75,7.75,0,0,1-.26.77,11.33,11.33,0,0,1-.53,1.12l-.09.16a10.47,10.47,0,0,1-.71,1.12h0l.34,21.11.23-.34c.17-.26.33-.52.48-.79,0,0,0-.1.08-.16l.21-.38c.12-.24.22-.49.32-.74s.16-.41.23-.62a.74.74,0,0,1,0-.14c0-.09,0-.17.07-.26s.09-.36.13-.54,0-.18.05-.26a1.1,1.1,0,0,0,0-.16,3.05,3.05,0,0,0,0-.41l0-.23q0-.37,0-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M150.48,22.7l-.24.28c-.12.14-.25.27-.38.41l-.29.3-.42.4-.46.42c-.3.26-.62.52-.95.78l-.33.24-.72.51-.35.24c-.24.16-.49.32-.75.47l-.38.24-.87.49-.3.17-1.21.61q-.78.38-1.59.72l-.44.17c-.4.17-.81.33-1.23.49l-.62.22c-.38.14-.76.27-1.15.39q-.33.12-.66.21l-1.25.37-.58.16c-.77.21-1.56.4-2.37.58l-.52.11c-.79.16-1.6.32-2.42.45l-.16,0-1,.14-.87.13-1,.11-.86.1c-.64.06-1.29.12-1.94.16s-1.17.06-1.76.09l-1.65,0H119.7l-1.51,0-1.14,0c-.48,0-1-.05-1.45-.09s-1,0-1.47-.1-1.22-.12-1.82-.19l-.42-.06c-.78-.1-1.56-.21-2.31-.34l-.32-.05c-.81-.15-1.61-.3-2.39-.48l-.44-.1c-.3-.06-.59-.14-.89-.21l-.51-.13-.92-.25-.41-.12-1.51-.47-.34-.12c-.42-.14-.82-.29-1.22-.44l-.31-.12c-.42-.16-.84-.34-1.25-.51l-.22-.1c-.34-.15-.67-.3-1-.46l-.36-.17-.85-.44-.3-.16c-.36-.2-.72-.4-1.06-.61l-.16-.1-.84-.55-.29-.2-.68-.5-.25-.19c-.29-.23-.58-.46-.84-.69l-.1-.09c-.23-.21-.46-.42-.67-.64L91.24,24c-.18-.18-.35-.36-.51-.55l-.19-.21c-.21-.25-.41-.51-.6-.76l0-.08c-.17-.23-.32-.47-.47-.71l-.14-.24L89,20.85a2.56,2.56,0,0,1-.11-.24c-.13-.27-.25-.54-.35-.81,0,0,0,0,0,0-.09-.26-.17-.53-.24-.79l-.06-.25c0-.21-.08-.41-.11-.62s0-.17,0-.25A7.91,7.91,0,0,1,88,17l.33,21.11c0,.28,0,.57.06.85,0,.08,0,.16,0,.25s.07.41.12.62,0,.16.06.25a7.67,7.67,0,0,0,.23.78s0,0,0,0a8.33,8.33,0,0,0,.34.82l.12.23a6.63,6.63,0,0,0,.31.59l.15.24c.14.24.3.48.46.71l.06.07a8.32,8.32,0,0,0,.6.76,2,2,0,0,0,.19.22l.5.55.22.22.67.63.1.09c.27.24.55.47.84.7l.25.19.68.49.3.21.83.54.16.1c.35.21.7.42,1.06.62L97,49l.85.43.36.18,1,.46.22.09c.41.18.83.35,1.26.52l.09,0,.21.07c.4.16.8.3,1.22.44l.34.12c.5.17,1,.33,1.52.48l.08,0a3,3,0,0,0,.32.09l.93.26.5.13.89.21.29.07.15,0c.78.17,1.58.33,2.39.47l.17,0,.15,0c.76.13,1.53.24,2.32.34l.19,0,.22,0c.6.08,1.21.14,1.82.2l.58.05.89,0,1.45.09.34,0h.8l1.51,0c.14,0,.29,0,.43,0h.66c.56,0,1.11,0,1.66,0h.55l1.2-.07,1.94-.16h0l.84-.09,1-.12.87-.12,1-.14h0l.11,0c.82-.14,1.63-.29,2.42-.46l.52-.11c.81-.17,1.6-.36,2.38-.57l.14,0,.44-.12,1.24-.37.66-.21,1.16-.39.61-.22c.42-.16.83-.32,1.23-.49l.45-.18c.54-.23,1.07-.47,1.58-.71l.05,0c.4-.19.78-.39,1.16-.59.11,0,.2-.11.31-.17.29-.16.58-.32.86-.49l.39-.23.74-.47.36-.24.18-.12.53-.39.33-.25c.33-.25.65-.51,1-.77l.28-.25.19-.18.41-.39.3-.3.37-.41.16-.17.09-.11c.25-.29.49-.59.7-.89l-.33-21.11C151,22.11,150.73,22.41,150.48,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M150.48,22.7l-.24.28c-.12.14-.25.27-.38.41l-.29.3-.42.4-.46.42c-.3.26-.62.52-.95.78l-.33.24-.72.51-.35.24c-.24.16-.49.32-.75.47l-.38.24-.87.49-.3.17-1.21.61q-.78.38-1.59.72l-.44.17c-.4.17-.81.33-1.23.49l-.62.22c-.38.14-.76.27-1.15.39q-.33.12-.66.21l-1.25.37-.58.16c-.77.21-1.56.4-2.37.58l-.52.11c-.79.16-1.6.32-2.42.45l-.16,0-1,.14-.87.13-1,.11-.86.1c-.64.06-1.29.12-1.94.16s-1.17.06-1.76.09l-1.65,0H119.7l-1.51,0-1.14,0c-.48,0-1-.05-1.45-.09s-1,0-1.47-.1-1.22-.12-1.82-.19l-.42-.06c-.78-.1-1.56-.21-2.31-.34l-.32-.05c-.81-.15-1.61-.3-2.39-.48l-.44-.1c-.3-.06-.59-.14-.89-.21l-.51-.13-.92-.25-.41-.12-1.51-.47-.34-.12c-.42-.14-.82-.29-1.22-.44l-.31-.12c-.42-.16-.84-.34-1.25-.51l-.22-.1c-.34-.15-.67-.3-1-.46l-.36-.17-.85-.44-.3-.16c-.36-.2-.72-.4-1.06-.61l-.16-.1-.84-.55-.29-.2-.68-.5-.25-.19c-.29-.23-.58-.46-.84-.69l-.1-.09c-.23-.21-.46-.42-.67-.64L91.24,24c-.18-.18-.35-.36-.51-.55l-.19-.21c-.21-.25-.41-.51-.6-.76l0-.08c-.17-.23-.32-.47-.47-.71l-.14-.24L89,20.85a2.56,2.56,0,0,1-.11-.24c-.13-.27-.25-.54-.35-.81,0,0,0,0,0,0-.09-.26-.17-.53-.24-.79l-.06-.25c0-.21-.08-.41-.11-.62s0-.17,0-.25A7.91,7.91,0,0,1,88,17l.33,21.11c0,.28,0,.57.06.85,0,.08,0,.16,0,.25s.07.41.12.62,0,.16.06.25a7.67,7.67,0,0,0,.23.78s0,0,0,0a8.33,8.33,0,0,0,.34.82l.12.23a6.63,6.63,0,0,0,.31.59l.15.24c.14.24.3.48.46.71l.06.07a8.32,8.32,0,0,0,.6.76,2,2,0,0,0,.19.22l.5.55.22.22.67.63.1.09c.27.24.55.47.84.7l.25.19.68.49.3.21.83.54.16.1c.35.21.7.42,1.06.62L97,49l.85.43.36.18,1,.46.22.09c.41.18.83.35,1.26.52l.09,0,.21.07c.4.16.8.3,1.22.44l.34.12c.5.17,1,.33,1.52.48l.08,0a3,3,0,0,0,.32.09l.93.26.5.13.89.21.29.07.15,0c.78.17,1.58.33,2.39.47l.17,0,.15,0c.76.13,1.53.24,2.32.34l.19,0,.22,0c.6.08,1.21.14,1.82.2l.58.05.89,0,1.45.09.34,0h.8l1.51,0c.14,0,.29,0,.43,0h.66c.56,0,1.11,0,1.66,0h.55l1.2-.07,1.94-.16h0l.84-.09,1-.12.87-.12,1-.14h0l.11,0c.82-.14,1.63-.29,2.42-.46l.52-.11c.81-.17,1.6-.36,2.38-.57l.14,0,.44-.12,1.24-.37.66-.21,1.16-.39.61-.22c.42-.16.83-.32,1.23-.49l.45-.18c.54-.23,1.07-.47,1.58-.71l.05,0c.4-.19.78-.39,1.16-.59.11,0,.2-.11.31-.17.29-.16.58-.32.86-.49l.39-.23.74-.47.36-.24.18-.12.53-.39.33-.25c.33-.25.65-.51,1-.77l.28-.25.19-.18.41-.39.3-.3.37-.41.16-.17.09-.11c.25-.29.49-.59.7-.89l-.33-21.11C151,22.11,150.73,22.41,150.48,22.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "175.71 37.67 175.94 52.2 162.83 61.55 162.6 47.03 175.71 37.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M162.6,47l13.11-9.36a19.21,19.21,0,0,1,6.56,3.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "182.27 41.34 182.5 55.87 162.83 61.55 162.6 47.03 182.27 41.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "163.19 47.13 163.41 61.66 162.83 61.55 162.6 47.03 163.19 47.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "163.46 47.18 163.69 61.7 163.41 61.66 163.19 47.13 163.46 47.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "164.04 47.28 164.27 61.81 163.69 61.7 163.46 47.18 164.04 47.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "164.75 47.4 164.98 61.93 164.27 61.81 164.04 47.28 164.75 47.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "165.1 47.46 165.33 61.99 164.98 61.93 164.75 47.4 165.1 47.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M185.15,56.86c0-.06,0-.12,0-.18a.43.43,0,0,1,0-.11l0-.29a.77.77,0,0,0,0-.15c0-.17,0-.35,0-.52v0l-.23-8.92a5,5,0,0,1,0,.55,1,1,0,0,1,0,.16c0,.13,0,.26,0,.39a1.16,1.16,0,0,1,0,.18,2.49,2.49,0,0,1-.09.37,1.21,1.21,0,0,1-.05.18,5.52,5.52,0,0,1-.18.53c-.1.26-.23.51-.36.77l-.06.11a9.06,9.06,0,0,1-.49.77h0l.23,8.92.16-.23c.12-.18.22-.36.33-.55a.37.37,0,0,0,.05-.11l.15-.26c.08-.17.15-.34.22-.51s.11-.28.16-.43,0-.06,0-.09a1.21,1.21,0,0,0,.05-.18A2.83,2.83,0,0,0,185.15,56.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "183.69 50.67 183.92 59.59 165.33 61.99 165.1 47.46 183.69 50.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M162.6,47l19.67-5.69c2.47,2.24,3.43,4.93,2.33,7.68a7.68,7.68,0,0,1-.91,1.65L165.1,47.46l-.35-.06-.71-.12-.58-.1-.27,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M183.67,50.7l.22,8.92c-7.41-1.29-14.82,3-18.56,2.37l-.23-14.53,18.57,3.24"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M165.1,47.46l18.59,3.21,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "183.69 50.67 183.92 59.59 183.9 59.62 183.66 50.7 183.69 50.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M183.35,60.31l.06-.08c.17-.2.33-.4.48-.61l-.22-8.92c-.15.21-.32.41-.49.61l-.17.2-.26.27-.2.21a3.58,3.58,0,0,1-.29.27l-.31.3c-.21.18-.43.36-.66.53l-.23.17c-.16.12-.32.24-.49.35l-.24.16-.52.33-.26.16-.6.34-.21.12-.83.42-1.09.49-.3.12-.86.34-.42.15-.79.27-.46.15-.85.25-.4.11c-.54.14-1.08.27-1.64.39l-.36.08c-.54.11-1.1.22-1.66.31l-.11,0-.66.1-.6.09-.7.08-.59.06c-.44.05-.88.08-1.33.11h0l.23,8.92,1.33-.11h0l.59-.07.68-.08.59-.08.67-.1h0l.08,0c.56-.09,1.12-.2,1.66-.31l.36-.08c.56-.12,1.1-.25,1.63-.39l.11,0,.3-.09.85-.25.45-.14.8-.27.42-.15.85-.34.31-.12,1.09-.49,0,0c.28-.13.54-.27.8-.41l.21-.11.6-.34L180,63l.51-.33.25-.16.12-.09c.13-.08.25-.17.37-.26l.23-.17c.22-.18.45-.35.65-.54l.19-.16.13-.13.29-.27.2-.21.26-.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M165.09,58.26l.23,8.92c-1.3-5.92-2.43-5.36-2.49-5.63L162.6,47c.06.26,1.19,5.31,2.49,11.23"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M162.6,47l.59.1.27,0,.58.1.71.12.35.06,18.57,3.24A11.43,11.43,0,0,1,182,52.56c-3.58,3.1-9.85,5.23-16.86,5.7C163.79,52.34,162.66,47.29,162.6,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M164.48,67.23l.84,0-.23-8.92c-.4,0-.81.05-1.21.06s-.76,0-1.14,0H162l-1,0-.79,0-1-.06-1-.07-1.25-.14-.29,0q-.81-.1-1.59-.24l-.22,0q-.84-.15-1.65-.33l-.3-.07-.61-.15-.35-.09-.63-.17-.28-.08q-.54-.15-1-.33l-.23-.08-.84-.3-.21-.08c-.29-.12-.58-.23-.86-.36l-.16-.06-.68-.32-.25-.12-.58-.3-.2-.11-.73-.42-.11-.07c-.2-.12-.39-.25-.58-.38l-.2-.14c-.16-.11-.32-.22-.47-.34l-.17-.13c-.2-.16-.4-.32-.58-.48l-.07-.06-.46-.43-.15-.16c-.12-.12-.24-.25-.35-.38a.86.86,0,0,1-.13-.14c-.15-.18-.29-.35-.42-.53l0,0c-.12-.16-.22-.32-.32-.48l-.1-.17c-.08-.13-.15-.27-.22-.41l-.08-.16a5.55,5.55,0,0,1-.24-.56v0a4.26,4.26,0,0,1-.17-.54c0-.05,0-.11,0-.17s-.06-.28-.08-.42a1.1,1.1,0,0,1,0-.18,5.67,5.67,0,0,1,0-.58l.23,8.92a5.67,5.67,0,0,0,.05.58.88.88,0,0,0,0,.17c0,.15.05.29.08.43s0,.11,0,.17.1.36.16.54v0c.07.19.15.37.24.56l.08.16.22.41a1.4,1.4,0,0,0,.1.16,5.14,5.14,0,0,0,.32.49l0,.05c.13.18.27.35.42.52l.13.15a4.14,4.14,0,0,0,.35.38l.15.15c.14.15.3.3.46.44l.07.06.57.48.18.13.47.34.2.14.58.38.11.07.72.42.21.11.58.3.25.12.68.31.15.07.87.36.07,0,.14.06.84.3.24.08,1,.33,0,0,.23.06.63.17.35.09.61.15.2,0,.1,0c.54.12,1.09.22,1.65.32l.12,0h.1q.78.14,1.59.24l.13,0h.16l1.25.14.4,0,.61,0,1,.06h.79l1,0H163q.57,0,1.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M143.26,41.5c4.72-4.1,14.16-6.51,23.8-5.64a36.17,36.17,0,0,1,8.65,1.81L162.6,47c.06.26,1.19,5.31,2.49,11.23a43.57,43.57,0,0,1-6.94-.07c-12.14-1.1-20-7-17.55-13.15A9.32,9.32,0,0,1,143.26,41.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M185.28,55.58l-.23-8.92a5,5,0,0,1,0,.55,1,1,0,0,1,0,.16c0,.13,0,.26,0,.39a1.16,1.16,0,0,1,0,.18,2.49,2.49,0,0,1-.09.37,1.21,1.21,0,0,1-.05.18,5.52,5.52,0,0,1-.18.53c-.1.26-.23.51-.36.77l-.06.11a9.06,9.06,0,0,1-.49.77h0l.23,8.92.16-.23c.12-.18.22-.36.33-.55a.37.37,0,0,0,.05-.11l.15-.26c.08-.17.15-.34.22-.51s.11-.28.16-.43,0-.06,0-.09a1.21,1.21,0,0,0,.05-.18,2.83,2.83,0,0,0,.09-.37c0-.06,0-.12,0-.18a.43.43,0,0,1,0-.11l0-.29a.77.77,0,0,0,0-.15c0-.17,0-.35,0-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M183.18,51.31l-.17.2-.26.27-.2.21a3.58,3.58,0,0,1-.29.27l-.31.3c-.21.18-.43.36-.66.53l-.23.17c-.16.12-.32.24-.49.35l-.24.16-.52.33-.26.16-.6.34-.21.12-.83.42-1.09.49-.3.12-.86.34-.42.15-.79.27-.46.15-.85.25-.4.11c-.54.14-1.08.27-1.64.39l-.36.08c-.54.11-1.1.22-1.66.31l-.11,0-.66.1-.6.09-.7.08-.59.06c-.44.05-.88.08-1.33.11s-.81.05-1.21.06-.76,0-1.14,0H162l-1,0-.79,0-1-.06-1-.07-1.25-.14-.29,0q-.81-.1-1.59-.24l-.22,0q-.84-.15-1.65-.33l-.3-.07-.61-.15-.35-.09-.63-.17-.28-.08q-.54-.15-1-.33l-.23-.08-.84-.3-.21-.08c-.29-.12-.58-.23-.86-.36l-.16-.06-.68-.32-.25-.12-.58-.3-.2-.11-.73-.42-.11-.07c-.2-.12-.39-.25-.58-.38l-.2-.14c-.16-.11-.32-.22-.47-.34l-.17-.13c-.2-.16-.4-.32-.58-.48l-.07-.06-.46-.43-.15-.16c-.12-.12-.24-.25-.35-.38a.86.86,0,0,1-.13-.14c-.15-.18-.29-.35-.42-.53l0,0c-.12-.16-.22-.32-.32-.48l-.1-.17c-.08-.13-.15-.27-.22-.41l-.08-.16a5.55,5.55,0,0,1-.24-.56v0a4.26,4.26,0,0,1-.17-.54c0-.05,0-.11,0-.17s-.06-.28-.08-.42a1.1,1.1,0,0,1,0-.18,5.67,5.67,0,0,1,0-.58l.23,8.92a5.67,5.67,0,0,0,.05.58.88.88,0,0,0,0,.17c0,.15.05.29.08.43s0,.11,0,.17.1.36.16.54v0c.07.19.15.37.24.56l.08.16.22.41a1.4,1.4,0,0,0,.1.16,5.14,5.14,0,0,0,.32.49l0,.05c.13.18.27.35.42.52l.13.15a4.14,4.14,0,0,0,.35.38l.15.15c.14.15.3.3.46.44l.07.06.57.48.18.13.47.34.2.14.58.38.11.07.72.42.21.11.58.3.25.12.68.31.15.07.87.36.07,0,.14.06.84.3.24.08,1,.33,0,0,.23.06.63.17.35.09.61.15.2,0,.1,0c.54.12,1.09.22,1.65.32l.12,0h.1q.78.14,1.59.24l.13,0h.16l1.25.14.4,0,.61,0,1,.06h.79l1,0H163q.57,0,1.14,0h.37l.84,0,1.33-.11h0l.59-.07.68-.08.59-.08.67-.1h.11c.56-.09,1.12-.2,1.66-.31l.36-.08c.56-.12,1.1-.25,1.63-.39l.11,0,.3-.09.85-.25.45-.14.8-.27.42-.15.85-.34.31-.12,1.09-.49,0,0c.28-.13.54-.27.8-.41l.21-.11.6-.34L180,63l.51-.33.25-.16.12-.09c.13-.08.25-.17.37-.26l.23-.17c.22-.18.44-.35.65-.54l.19-.16.13-.13.29-.27.2-.21.26-.28.11-.11.06-.08c.17-.2.33-.4.48-.61l-.22-8.92C183.52,50.91,183.35,51.11,183.18,51.31Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCourseIconIntermediate);
export default __webpack_public_path__ + "static/media/new-course-icon-intermediate.dc3b2ccbc5198858c63bc3fea835710b.svg";
export { ForwardRef as ReactComponent };